// Shared validation functions
import { isValidEmail, isSingleByte } from '../utils/index.js';
export { validateMagnetFlow, validateMagnetPackageFlows } from './magnetFlow.js';
export { auditMagnetPackage, MAGNET_HEALTH_RULE_VERSION } from './magnetHealth.js';

/**
 * Validate signup form data
 * @param {Object} data - Form data
 * @returns {Object} { valid: boolean, errors: string[] }
 */
export function validateSignup(data) {
  const errors = [];

  if (!data.email) errors.push('Email is required');
  else if (!isValidEmail(data.email)) errors.push('Invalid email format');
  else if (!isSingleByte(data.email)) errors.push('Email must contain only single-byte characters');

  if (!data.hash) errors.push('Password is required');
  if (!data.first) errors.push('First name is required');
  if (!data.last) errors.push('Last name is required');

  return {
    valid: errors.length === 0,
    errors
  };
}

/**
 * Validate signin form data
 * @param {Object} data - Form data
 * @returns {Object} { valid: boolean, errors: string[] }
 */
export function validateSignin(data) {
  const errors = [];

  if (!data.email) errors.push('Email is required');
  if (!data.hash) errors.push('Password is required');

  return {
    valid: errors.length === 0,
    errors
  };
}

/**
 * Validate password reset data
 * @param {Object} data - Form data
 * @returns {Object} { valid: boolean, errors: string[] }
 */
export function validatePasswordReset(data) {
  const errors = [];

  if (!data.email) errors.push('Email is required');
  if (!data.hash) errors.push('New password is required');

  return {
    valid: errors.length === 0,
    errors
  };
}
